import { render, staticRenderFns } from "./Pimples.vue?vue&type=template&id=0e2c3641"
import script from "./Pimples.vue?vue&type=script&lang=js"
export * from "./Pimples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports